import supHttps from '../init/supHttps';

/*
 * Support > Finance (backend: controllers/supportAdmin/finance/*)
 *   filters: { from, to, type, organizerId, listingId, bookedVia, limit, offset }
 */
const clean = (params = {}) =>
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined));

//SUP-FIN-01 totals, by type, trend
export const financeSummaryFun = (filters) =>
    supHttps.get('/support/admin/finance/summary', { params: clean(filters) });

//SUP-FIN-02 rows of a report: organizers | listings | payments | refunds | payouts | tax
export const financeReportFun = (report, filters) =>
    supHttps.get(`/support/admin/finance/report/${report}`, { params: clean(filters) });

//SUP-FIN-03 organizers + listings for the filter dropdowns
export const financeOptionsFun = (type) => supHttps.get('/support/admin/finance/options', { params: clean({ type }) });

//SUP-FIN-04 Excel workbook of every report for the filters (blob)
export const financeExportFun = (filters) =>
    supHttps.get('/support/admin/finance/export', { params: clean(filters), responseType: 'blob' });

//SUP-FIN-05 payout bill (HTML, printable) for one payout
export const financeBillFun = (type, payoutId) =>
    supHttps.get(`/support/admin/finance/bill/${type}/${payoutId}`, { responseType: 'text' });
